var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 13.6083C8.00827 13.6083 6.3916 11.9916 6.3916 9.99993C6.3916 8.00827 8.00827 6.3916 9.99993 6.3916C11.9916 6.3916 13.6083 8.00827 13.6083 9.99993C13.6083 11.9916 11.9916 13.6083 9.99993 13.6083ZM9.99993 7.6416C8.69993 7.6416 7.6416 8.69993 7.6416 9.99993C7.6416 11.2999 8.69993 12.3583 9.99993 12.3583C11.2999 12.3583 12.3583 11.2999 12.3583 9.99993C12.3583 8.69993 11.2999 7.6416 9.99993 7.6416Z",
    fill: "#93989F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 17.5167C6.86657 17.5167 3.90824 15.6834 1.8749 12.5001C0.991569 11.1251 0.991569 8.8834 1.8749 7.50006C3.91657 4.31673 6.8749 2.4834 9.9999 2.4834C13.1249 2.4834 16.0832 4.31673 18.1166 7.50006C18.9999 8.87506 18.9999 11.1167 18.1166 12.5001C16.0832 15.6834 13.1249 17.5167 9.9999 17.5167ZM9.9999 3.7334C7.30824 3.7334 4.73324 5.35007 2.93324 8.17507C2.30824 9.15007 2.30824 10.8501 2.93324 11.8251C4.73324 14.6501 7.30824 16.2667 9.9999 16.2667C12.6916 16.2667 15.2666 14.6501 17.0666 11.8251C17.6916 10.8501 17.6916 9.15007 17.0666 8.17507C15.2666 5.35007 12.6916 3.7334 9.9999 3.7334Z",
    fill: "#93989F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2397262332cd953aff1368ac03d209df.svg";
export { ForwardRef as ReactComponent };